// extracted by mini-css-extract-plugin
export var growableInput = "_redotech-redo-web-lib-arbiter-components-input-redo-tag-input-field-growable-input";
export var tagContainer = "_redotech-redo-web-lib-arbiter-components-input-redo-tag-input-field-tag-container";
export var textInput = "_redotech-redo-web-lib-arbiter-components-input-redo-tag-input-field-text-input";